"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const BaseInput_1 = __importDefault(require("../../atoms/inputs/BaseInput"));
const clsx_1 = __importDefault(require("clsx"));
const atoms_1 = require("../../atoms");
exports.default = react_1.forwardRef(function MultiInput({ value = [], onChange, rounded = 'all', ...props }) {
    const [current, setCurrent] = react_1.useState('');
    const addCurrentValue = () => {
        if (current.length > 0) {
            onChange === null || onChange === void 0 ? void 0 : onChange([...value, current]);
            setCurrent('');
        }
    };
    const removeValue = (index) => {
        const newValue = value.filter((_, i) => i !== index);
        onChange === null || onChange === void 0 ? void 0 : onChange(newValue);
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            addCurrentValue();
        }
    };
    return (react_1.default.createElement("div", { className: clsx_1.default('placeholder-gray-500 dark:bg-black-600 bg-white focus:border-highlight-300 focus:ring-highlight-500', 'relative focus:z-10 block px-3 w-full', 'text-gray-900 dark:text-white border border-gray-300 dark:border-gray-800', 'focus:outline-none appearance-none sm:text-sm sm:leading-5', 'flex flex-row flex-wrap items-center', { 'rounded-md ': rounded === 'all' }, { 'rounded-none  rounded-b-md': rounded === 'bottom' }, { 'rounded-none  rounded-t-md': rounded === 'top' }) }, value === null || value === void 0 ? void 0 :
        value.map((v, index) => (react_1.default.createElement("div", { className: 'pl-2 mx-1 bg-gray-200 dark:bg-gray-600 rounded flex flex-row items-center my-1', key: v },
            v,
            react_1.default.createElement(atoms_1.IconButton, { icon: atoms_1.CloseIcon, type: atoms_1.ButtonType.button, size: 'small', onClick: () => removeValue(index) })))),
        react_1.default.createElement(BaseInput_1.default, Object.assign({}, props, { className: 'focus:outline-none appearance-none bg-transparent flex-grow py-2', value: current, onChange: (e) => setCurrent(e.target.value), onKeyDown: handleKeyDown, onBlur: () => addCurrentValue() }))));
});
